import { ref } from 'vue'
import { registerSW } from 'virtual:pwa-register'

export const useAppUpdate = () => {
  const needRefresh = ref(false)
  const offlineReady = ref(false)
  let updateServiceWorker = () => Promise.resolve()

  if (process.client) {
    updateServiceWorker = registerSW({
      onNeedRefresh() {
        needRefresh.value = true
      },
      onOfflineReady() {
        offlineReady.value = true
      },
      immediate: true
    })
  }

  const close = () => {
    offlineReady.value = false
    needRefresh.value = false
  }

  const update = async () => {
    await updateServiceWorker()
    close()
  }

  return {
    needRefresh,
    offlineReady,
    update,
    close
  }
}